<template>
    <button
        type="button"
        class="a-icon-button"
        @click="onClick"
    >
        <svg-icon
            original
            :name="`icons/${icon}`"
        />
        <span>
            {{ text }}
        </span>
    </button>
</template>

<script>
export default {
    name: 'AIconButton',
    props: {
        icon: {
            type: String,
            required: true
        },
        text: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }) {
        function onClick() {
            emit('onClick');
        }

        return {
            onClick
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />